import Blue from "~/core";

new Blue({
	name: 'cta-match-height',
	selector: ".cta--feature-list",
	setup(container) {
		const cards = [...container.querySelectorAll('.cta')];

		const adjustHeight = () => {
			const rows = cards.reduce((rows, card, i) => {
				let row;
				if (i === 0) {
					row = [];
					rows.push(row)
				}
				else row = rows[rows.length - 1];

				if (row.length && card.getBoundingClientRect().top > row[0].getBoundingClientRect().top) {
					row = [];
					rows.push(row);
				}

				row.push(card);
				return rows;
			
			}, []);

			rows.forEach(row => {
				let height = 0;
				row.forEach(card => card.querySelector('.cta__title').style.height = '');
				if (row.length > 1) {
					row.forEach(card => height = Math.max(height, card.querySelector('.cta__title').offsetHeight));
					row.forEach(card => card.querySelector('.cta__title').style.height = `${height}px`);
				}
			})
		}

		adjustHeight();
		this.$screen.xs.addEventListener('change', adjustHeight);
		this.$screen.sm.addEventListener('change', adjustHeight);
		this.$screen.md.addEventListener('change', adjustHeight);
		this.$screen.lg.addEventListener('change', adjustHeight);
		this.$screen.xl.addEventListener('change', adjustHeight);
		setTimeout(adjustHeight, 500);		// added to re-adjust after text size is fully loaded
	}
});